import { FlowItem, FlowParameterRunItem, IIdItem } from './resourceParts';

export type FlowRun = FlowItem & IIdItem & FlowParameterRunItem & {
  readonly startedAt: string; // YYYY-MM-DDThh:mm:ssZ
  readonly completedAt: string; // YYYY-MM-DDThh:mm:ssZ
  readonly status: string; // [ PENDING, INPROGRESS, SUCCESS, FAILED, CANCELLED ]
  readonly taskId: string;
  readonly triggerType: FlowRunTriggerType;
  readonly errorMessage: string;
  readonly outputStepIds: ReadonlyArray<string>;
  readonly outputStepRunIds: ReadonlyArray<string>;
};

export enum FlowRunTriggerType {
  adhoc = 'AdHoc',
  scheduled = 'Scheduled',
}
